import styled, { CSSObject } from 'styled-components';
import { font_montserrat, tabletPortrait } from '../global.styles';

interface StyledLabelProps {
  fontSize?: CSSObject['fontSize'];
  fontWeight?: CSSObject['fontWeight'];
  color?: CSSObject['color'];
  htmlFor: string;
  display?: string;
  marginLeft?: string;
  mobileprops?: {
    fontSize?: CSSObject['fontSize'];
    fontWeight?: CSSObject['fontWeight'];
    color?: CSSObject['color'];
  };
}
export const StyledLabel = styled('h3').withConfig({
  shouldForwardProp: (prop) => !['fontSize', 'fontWeight', 'marginLeft', 'mobileprops'].includes(prop),
})<StyledLabelProps>`
  font-size: ${(props) => props.fontSize || '16px'};
  font-weight: ${(props) => props.fontWeight || '700'};
  color: ${(props) => props.color || '#000'};
  display: ${(props) => props.display || 'block'};
  margin-bottom: 8px;
  margin-left: ${(props) => props.marginLeft || '0'};
  font-family: ${font_montserrat};

  ${tabletPortrait} {
    font-size: ${(props) => props.mobileprops?.fontSize || props.fontSize || '14px'};
    font-weight: ${(props) => props.mobileprops?.fontWeight || props.fontWeight || '700'};
    color: ${(props) => props.mobileprops?.color || props.color || '#000'};
  }
`;
